import acrylic1 from "../assets/images/Gallarey/AcrylicFlooring/1.jpg";
import acrylic2 from "../assets/images/Gallarey/AcrylicFlooring/2.jpg";
import acrylic3 from "../assets/images/Gallarey/AcrylicFlooring/3.jpg";
import acrylic4 from "../assets/images/Gallarey/AcrylicFlooring/4.jpg";
import acrylic5 from "../assets/images/Gallarey/AcrylicFlooring/5.jpg";
import acrylic6 from "../assets/images/Gallarey/AcrylicFlooring/6.jpg";
import acrylic7 from "../assets/images/Gallarey/AcrylicFlooring/7.jpg";
import acrylic8 from "../assets/images/Gallarey/AcrylicFlooring/8.jpg";
import acrylic9 from "../assets/images/Gallarey/AcrylicFlooring/9.jpg";
import acrylic10 from "../assets/images/Gallarey/AcrylicFlooring/10.jpg";
import acrylic11 from "../assets/images/Gallarey/AcrylicFlooring/11.jpg";

import landscape1 from "../assets/images/Gallarey/ArtificialGrassforLandscape/1.jpg";
import landscape2 from "../assets/images/Gallarey/ArtificialGrassforLandscape/2.jpg";
import landscape3 from "../assets/images/Gallarey/ArtificialGrassforLandscape/3.jpg";
import landscape4 from "../assets/images/Gallarey/ArtificialGrassforLandscape/4.jpg";
import landscape5 from "../assets/images/Gallarey/ArtificialGrassforLandscape/5.jpg";
import landscape6 from "../assets/images/Gallarey/ArtificialGrassforLandscape/6.jpg";
import landscape7 from "../assets/images/Gallarey/ArtificialGrassforLandscape/7.jpg";
import landscape8 from "../assets/images/Gallarey/ArtificialGrassforLandscape/8.jpg";
import landscape9 from "../assets/images/Gallarey/ArtificialGrassforLandscape/9.jpg";
import landscape10 from "../assets/images/Gallarey/ArtificialGrassforLandscape/10.jpg";
import landscape11 from "../assets/images/Gallarey/ArtificialGrassforLandscape/11.jpg";

import sports1 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/1.jpg";
import sports2 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/2.jpg";
import sports3 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/3.jpg";
import sports4 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/4.jpg";
import sports5 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/5.jpg";
import sports6 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/6.jpg";
import sports7 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/7.jpg";
import sports8 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/8.jpg";
import sports9 from "../assets/images/Gallarey/ArtificialGrassforSportsSurfaces/9.jpg";

import gym1 from "../assets/images/Gallarey/GYMFlooring/1.jpg";
import gym2 from "../assets/images/Gallarey/GYMFlooring/2.jpg";
import gym3 from "../assets/images/Gallarey/GYMFlooring/3.jpg";
import gym4 from "../assets/images/Gallarey/GYMFlooring/4.jpg";
import gym5 from "../assets/images/Gallarey/GYMFlooring/5.jpg";
import gym6 from "../assets/images/Gallarey/GYMFlooring/6.jpg";
import gym7 from "../assets/images/Gallarey/GYMFlooring/7.jpg";
import gym8 from "../assets/images/Gallarey/GYMFlooring/8.jpg";
import gym9 from "../assets/images/Gallarey/GYMFlooring/9.jpg";

import padel1 from "../assets/images/Gallarey/PadelTennis/1.jpg";
import padel2 from "../assets/images/Gallarey/PadelTennis/2.jpg";
import padel3 from "../assets/images/Gallarey/PadelTennis/3.jpg";
import padel4 from "../assets/images/Gallarey/PadelTennis/4.jpg";
import padel5 from "../assets/images/Gallarey/PadelTennis/5.jpg";
import padel6 from "../assets/images/Gallarey/PadelTennis/6.jpg";

import tartan1 from "../assets/images/Gallarey/TartanFlooring/1.jpg";
import tartan2 from "../assets/images/Gallarey/TartanFlooring/2.jpg";
import tartan3 from "../assets/images/Gallarey/TartanFlooring/3.jpg";
import tartan4 from "../assets/images/Gallarey/TartanFlooring/4.jpg";
import tartan5 from "../assets/images/Gallarey/TartanFlooring/5.jpg";
import tartan6 from "../assets/images/Gallarey/TartanFlooring/6.jpg";

export const GALLERIES = {
  element1: {
    descriptionKey: "Artificial Grass for Sports Surfaces",
    buttonKey: "Artificial Grass for Sports Surfaces",
    images: [sports1, sports2, sports3, sports4, sports5, sports6, sports7, sports8, sports9],
  },
  element2: {
    descriptionKey: "Artificial Grass for Landscape",
    buttonKey: "Artificial Grass for Landscape",
    images: [
      landscape1, landscape2, landscape3, landscape4, landscape5, landscape6,
      landscape7, landscape8, landscape9, landscape10, landscape11,
    ],
  },
  element3: {
    descriptionKey: "GYM Flooring",
    buttonKey: "GYM Flooring",
    images: [gym1, gym2, gym3, gym4, gym5, gym6, gym7, gym8, gym9],
  },
  element4: {
    descriptionKey: "Padel Tennis Flooring",
    buttonKey: "Padel Tennis Flooring",
    images: [padel1, padel2, padel3, padel4, padel5, padel6],
  },
  element5: {
    descriptionKey: "Tartan Flooring",
    buttonKey: "Tartan Flooring",
    images: [tartan1, tartan2, tartan3, tartan4, tartan5, tartan6],
  },
  element6: {
    descriptionKey: "Acrylic Flooring",
    buttonKey: "Acrylic Flooring",
    images: [
      acrylic1, acrylic2, acrylic3, acrylic4, acrylic5, acrylic6,
      acrylic7, acrylic8, acrylic9, acrylic10, acrylic11,
    ],
  },
};

export const GALLERY_ORDER = [
  "element6",
  "element1",
  "element2",
  "element3",
  "element4",
  "element5",
];

export const DEFAULT_GALLERY_ID = "element6";
